<template>
  <div class="animated fadeIn ChartsOfAccounts--ChartsOfAccounts-list">
    <fixed-header title="Chart of Accounts List" :records="pageInfo.totalItems" hideBackBtn />
    <div class="card">
      <div class="card-body d-flex flex-column">
      <b-form @submit="onSubmit" @reset="onReset" inline class="mb-2">
        <b-form-group class="required mr-2" label="Name">
          <b-form-input
              type="text"
              :class="{ 'is-invalid': $v.formData.accountName.$error }"
              @blur="$v.formData.accountName.$touch()"
              v-model.trim="formData.accountName"
            ></b-form-input>
            <b-form-invalid-feedback>Account name is required</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Account Type" class="required mr-2">
            <b-form-select
              v-model="formData.accountTypeId"
              :class="{ 'is-invalid': $v.formData.accountTypeId.$error }"
              :plain="true"
              @change="formData.qbAccountListID = null"
            >
              <option :value="null"></option>
              <option
                v-for="(type,key,index) in accountTypes"
                v-bind:key="index"
                v-bind:value="type"
              >{{key}}</option>
            </b-form-select>
            <b-form-invalid-feedback>Please select account type</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Qbo Account" class="required mr-2">
            <b-form-select
              v-model="formData.qbAccountListID"
              :class="{ 'is-invalid': $v.formData.qbAccountListID.$error }"
              :plain="true"
            >
              <!-- @change="filterItems" -->

              <!-- <template v-slot:first>
                <option :value="null"></option>
              </template> -->
              <option :value="null"></option>
              <option
                v-for="(type, index) in sortSelect(filteredQboAccounts,'text')"
                v-bind:key="index"
                v-bind:value="type.value"
              >{{type.text}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Qbo Item" class="mr-2">
            <b-form-select
              v-model="formData.qboItemId"
              :plain="true"
            >
              <option :value="null"></option>
              <option
                v-for="(type, index) in sortSelect(mappedQboItems,'text')"
                v-bind:key="index"
                v-bind:value="type.value"
              >{{type.text}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group >
            <b-button type="submit" variant="primary" class="mr-2 mt-1">{{submitButtonName}}</b-button>
            <b-button type="reset" variant="secondary" class="mr-2 mt-1">Cancel</b-button>
          </b-form-group>
        </b-form>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :pageable="pageable"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :gridId="gridId"
          :itemData="itemData"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :sortMethod="sortGrid"
          :onDelete="onDelete"
          :handleRowClick="handleRowClick"
          :styleCustom="'height: 715px'"
          @getData="onGetData"
          :isTblLoader="tblLoader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  GRID_ID, GRID_PAGE_SIZES
} from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import { required } from 'vuelidate/lib/validators';
import { ACCOUNT_TYPES } from './constants';
export default {
  components: {
    GridSettings,
    GridComponent,
    FixedHeader
  },
  data() {
    return {
      fields: gridFields,
      gridId: GRID_ID.CHARTS_OF_ACCOUNTS,
      selectedRowItemId: 0,
      formData: {
        id:0,
        accountTypeId: null,
        accountName: null,
        qbAccountListID: null,
        qboItemId: null,
      },
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      accountTypes: ACCOUNT_TYPES,
      filteredQboItems: []
      // qboAccounts: QBO_ACCOUNTS,
    };
  },
  validations: {
    formData: {
      accountTypeId: { required },
      accountName: { required },
      qbAccountListID: { required },
      // qboItemId: { required }
    },
  },
  computed: {
    ...mapGetters('chartsOfAccounts', [
      'chartsOfAccountsList',
      'pageInfo',
      'lastOpenedId',
      'tblLoader',
      'pageInfo'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('quickBooks', ['qboAccounts', 'qboItems']),
    submitButtonName() {
      return this.selectedRowItemId ? 'Update' : 'Save';
    },
    itemData() {
      if (this.chartsOfAccountsList == undefined || !this.chartsOfAccountsList.length) return [];
      return this.chartsOfAccountsList.map(ChartsOfAccountsList => ({
        ...ChartsOfAccountsList,
        selected: ChartsOfAccountsList.id === this.selectedRowItemId,
      }));
    },
    filteredQboAccounts() {
      if (this.formData.accountTypeId == null || this.formData.accountTypeId == undefined) {
        this.formData.qboItems = null;
        return [];
      }
      else {
        const accountTypeSelected = (Object.keys(ACCOUNT_TYPES).find(key => ACCOUNT_TYPES[key] == this.formData.accountTypeId)).replace(/\s+/g, '');
        return this.qboAccounts.filter(acct => acct.accountType == accountTypeSelected).map(acct => ({ value: acct.id, text: acct.name }));
      }
    },
    mappedQboItems() {
      return this.qboItems.map(item => ({ value: item.id, text: item.name }));
    }
  },
  methods: {
    ...mapActions('chartsOfAccounts', [
      'getAll',
      'manage',
      'deleteRecord',
      'sortGrid'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    filterItems() {
      console.log(this.formData.qbAccountListID, 'QB Account List Id')
      this.formData.qboItemId = null;
      // this.filteredQboItems = this.qboItems.filter(item =>
      //   item.incomeAccountRefValue == this.formData.qbAccountListID || item.expenseAccountRefValue == this.formData.qbAccountListID
      // ).map(item => ({ value: item.id, text: item.name }));
    },
    async onSubmit(evt) {
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        return;
      } else {
        this.formData.active=true
        const result = await this.manage(this.formData);
        if(result){
          this.getChartsOfAccounts(evt);
        }
      }
    },
    onReset(evt) {
      this.formData = {}
      this.selectedRowItemId=0
      this.$v.$reset();
      this.$v.formData.$reset();
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    handleRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      console.log(row.dataItem, 'Data Item')
      this.formData = {
        id:row.dataItem.id,
        accountTypeId: row.dataItem.accountTypeId,
        accountName: row.dataItem.accountName,
        qbAccountListID: row.dataItem.qbAccountListID,
        qboItemId: row.dataItem.qboItemId
      }
      this.filterItems();
    },
    async onDelete(row) {
      const deleteConfirmed = await this.openConfirmBox({});
      if (deleteConfirmed) {
        await this.deleteRecord(row.id);
        //Get the data
        this.getChartsOfAccounts()
      }
    },
    async onGetData(params) {
      await this.getAll({
        ...params,
        pageNumber: 0
      });
    },
    async getChartsOfAccounts(evt) {
      this.onReset(evt)
      await this.getAll({});
      /*await this.getList({
        ...this.gridSettings.sort,
        pageNumber: 0
      });*/
    },
  },
  mounted() {
    this.getAll({});
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#ChartsOfAccounts-header-nav {
  width: 100%;
  z-index: 1000;
  //position: fixed;
  border-bottom: 1px solid rgb(200, 206, 211);
  background: #fff;
}

#ChartsOfAccounts-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}

.ChartsOfAccounts {
  &--ChartsOfAccounts-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }
    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
